import {Guid} from "./guid"

export interface ILookupItem {
  id: number
  label: string
}

export enum State {
  DEFAULT,
  FAIL,
  SUCCESS
}

export enum DaysOfWeek {
  MONDAY = "Monday",
  TUESDAY = " Tuesday",
  WEDNESDAY = "Wednesday",
  THURSDAY = "Thursday",
  FRIDAY = "Friday",
  SATURDAY = "Saturday",
  SUNDAY = "Sunday"
}
export interface IResult<T> {
  readonly value?: T
  readonly error?: string
}
export type Nullable<T> = T | null

export interface IDocument extends File {
  id: Guid
}
